export type IndustryPreset = "HORECA" | "BEAUTY" | "FITNESS" | "RETAIL" | "SERVICES";

export const INDUSTRY_PRESETS: readonly IndustryPreset[] = [
    "HORECA",
    "BEAUTY",
    "FITNESS",
    "RETAIL",
    "SERVICES",
] as const;

export const INDUSTRY_PRESET_LABELS: Record<IndustryPreset, string> = {
    HORECA: "HoReCa (ресторан / кафе)",
    BEAUTY: "Салон красоты",
    FITNESS: "Фитнес-клуб",
    RETAIL: "Розница",
    SERVICES: "Услуги (B2B / сервисный бизнес)",
};

export const INDUSTRY_PRESET_OPTIONS = INDUSTRY_PRESETS.map((value) => ({
    value,
    label: INDUSTRY_PRESET_LABELS[value],
}));

export function isIndustryPreset(value: string): value is IndustryPreset {
    return (INDUSTRY_PRESETS as readonly string[]).includes(value);
}
